import { FormEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/Elements/Input';
import WarnList from '../../../components/Elements/WarnList';
import AuthCard from './AuthCard';

interface IForm {
    onSubmit: FormEventHandler<HTMLFormElement>;
    warns: any;
    loading: boolean;
}

export default function LoginForm({ onSubmit, warns, loading }: IForm) {
    const navigate = useNavigate();

    return (
        <AuthCard titulo='Login' subtitulo='Entre com seu e-mail e senha.'>
            <form autoComplete='off' onSubmit={onSubmit}>
                <WarnList warns={warns}/>
                <Input id='email' label='E-mail' type='email' />
                <Input id='password' label='Senha' type='password' />
                <button type='submit' disabled={loading} className='auth-botao'>Entrar</button>
                <div className='auth-rodape'>
                    <button type='button' className='auth-link' onClick={() => navigate("/auth/password-recovery")}>Esqueceu a senha?</button>
                    {/* A tela de cadastro ja existia em /auth/register, mas nao havia caminho
                        nenhum ate ela: so chegava quem digitasse a URL na mao. */}
                    <button type='button' className='auth-link' onClick={() => navigate("/auth/register")}>Criar conta</button>
                </div>
            </form>
        </AuthCard>
    )
}
